module.exports = __webpack_public_path__ + "static/media/校园多楼宇综合供热2.b79a5a1b.jpg";